module.exports = __webpack_public_path__ + "img/topography.7dcb7a1a.svg";